<template>
  <Modal
    title="Vertrag in Ruhe setzen"
    @close="$emit('close')"
  >
    <template #body>
      <form>
        <BasicDatepicker
          v-model="ruhesetzungDatum"
          label="Datum der Abmeldung"
          required
          :disabled-dates="{from: dayjs().toDate()}"
        />
        <div class="form-row justify-content-end mt-5">
          <p
            v-if="error"
            class="text-danger w-100 text-right"
          >
            {{ error }}
          </p>
          <div>
            <button
              type="button"
              class="btn btn-secondary mr-2"
              @click="$emit('close')"
            >
              Abbrechen
            </button>
            <button
              type="button"
              class="btn btn-orange"
              :disabled="loading"
              @click="ruheVertrag"
            >
              <i
                v-if="loading"
                class="fad fa-circle-notch fa-spin"
              />
              Vertrag in Ruhe setzen
            </button>
          </div>
        </div>
      </form>
    </template>
  </Modal>
</template>
<script>
import Modal from '../Modal.vue'
import feathersClient from '@/api'
import BasicDatepicker from '../../components/BaseComponents/BasicDatepicker.vue'
import dayjs from 'dayjs'

export default {
  $_veeValidate: {
    validator: 'new' // give me my own validator scope.
  },
  components: {
    Modal,
    BasicDatepicker
  },
  props: {
    orderId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      ruhesetzungDatum: null,
      dayjs,
      loading: false,
      error: null
    }
  },
  methods: {
    async ruheVertrag () {
      this.loading = true
      this.error = null
      if (!await this.$validator.validateAll()) return
      try {
        await feathersClient.service('hs-order-process-vertrag-ruhesetzung').create({
          hsOrderId: this.orderId,
          ruhesetzungDatum: this.ruhesetzungDatum
        })
        this.$emit('close')
      } catch (error) {
        console.error(error)
        this.error = 'Es ist ein Fehler aufgetreten.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
